import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './footerStyles.css'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },

    borderRadius: '60px'

  },
  buttoninactive: {
    color: "#E9E9EC"
  },

  buttonactive: {
    color: "primary"
  }
}));



export default function TusDatosPresion({ sistolica, diastolica, textStyle }) {
  const classes = useStyles();
  const [active, setActive] = React.useState(false);

  return (

    <div className='buttonHistoricPresion'>
      <button className="button1">
        <div className="number" style={textStyle}><b>{sistolica ? sistolica === "NaN" ? "-" : sistolica : 0}</b></div>
        <div className="text" style={textStyle}>Sistolica</div>
      </button>
      <button className="button3">
        <div className="number" style={textStyle}><b>{diastolica ? diastolica === "NaN" ? "-" : diastolica : 0}</b></div>
        <div className="text" style={textStyle}>Diastolica</div>
      </button>
    </div>

  );
}